import settings from '@shared/settings'
import floatParser from '@shared/utils/floatParser'

function allowedNumberOfDigitsAfterDecimal(country) {
    switch (country) {
        case 'al':
        case 'ba':
        case 'bg':
        case 'md':
            return 2
        case 'mk':
            return 0
        default:
            throw new Error(`Not implemented for ${country}`)
    }
}

export default {
    validate(value) {
        if (isNaN(floatParser(value))) return false
        if (typeof value !== 'string') value = value.toString()
        const allowedDigitsAfterDecimal = allowedNumberOfDigitsAfterDecimal(settings.country())
        if ((allowedDigitsAfterDecimal) === 0) {
            if (value.match(/[.,]/g) != null) return false
        } else if (allowedDigitsAfterDecimal === 2) {
            if (/[.,]/g.exec(value) == null) return true
            if (value.length - 1 - /[.,]/g.exec(value).index > 2) return false
        }
        return true
    }
}
